import { Tier } from "@/types";

export const TIERS: Tier[] = [
  { id: 'rookie', name: 'Rookie', description: 'Starting tier', imageUrl: '', pointsThreshold: 0, minPoints: 0, maxPoints: 49, color: 'text-muted-foreground', icon: '🎯' },
  { id: 'rising', name: 'Rising Star', description: 'Rising tier', imageUrl: '', pointsThreshold: 50, minPoints: 50, maxPoints: 149, color: 'text-success', icon: '⭐' },
  { id: 'professional', name: 'Professional', description: 'Professional tier', imageUrl: '', pointsThreshold: 150, minPoints: 150, maxPoints: 349, color: 'text-primary', icon: '💼' },
  { id: 'expert', name: 'Expert', description: 'Expert tier', imageUrl: '', pointsThreshold: 350, minPoints: 350, maxPoints: 699, color: 'text-energy', icon: '🚀' },
  { id: 'master', name: 'Master', description: 'Master tier', imageUrl: '', pointsThreshold: 700, minPoints: 700, maxPoints: 1199, color: 'text-warning', icon: '👑' },
  { id: 'champion', name: 'Champion', description: 'Champion tier', imageUrl: '', pointsThreshold: 1200, minPoints: 1200, maxPoints: Infinity, color: 'text-destructive', icon: '🏆' },
];

export const getCurrentTier = (totalPoints: number): Tier => {
  return TIERS.find(tier => totalPoints >= tier.minPoints && totalPoints <= tier.maxPoints) || TIERS[0];
};

export const getTiers = (): Tier[] => {
  return TIERS;
};